module.exports = __webpack_public_path__ + "img/img-trading-p2-1.faa137d9.png";